module.exports = __webpack_public_path__ + "static/media/PeopleImage.21832429.png";